import { useEffect } from 'react';

import { getMobileStoreType, StoreTypes } from '../../helpers/storeLinks';
import useStoreUrls from './useStoreUrls';

// A PHONE VISITOR GOES STRAIGHT TO THEIR STORE, WITH NO PAGE IN BETWEEN
const useStoreRedirect = (isMobileSize: boolean) => {
  const { playStoreUrl, appStoreUrl } = useStoreUrls();

  useEffect(() => {
    const storeType = getMobileStoreType();
    if (!isMobileSize || storeType === null) return;

    const isAndroid = storeType === StoreTypes.playStore;
    window.location.href = isAndroid ? playStoreUrl : appStoreUrl;
  }, [isMobileSize, playStoreUrl, appStoreUrl]);
};

export default useStoreRedirect;
